"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Tiktok = function Tiktok(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Navigation-/-Footer-/-Mobile",
    transform: "translate(-136.000000, -378.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group",
    transform: "translate(82.000000, 378.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "tik-tok",
    transform: "translate(54.000000, 0.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M20.2964579,5.27178956 C17.7757983,5.27178956 15.7250829,3.22229006 15.7250829,0.703125 C15.7250829,0.314758312 15.4099546,0 15.0215407,0 L11.2535596,0 C10.8649625,0 10.5500175,0.314758313 10.5500175,0.703125 L10.5500175,16.1422119 C10.5500175,17.623169 9.34446869,18.8280029 7.86244981,18.8280029 C6.38061418,18.8280029 5.17506546,17.623169 5.17506546,16.1422119 C5.17506546,14.6610718 6.38061418,13.4562378 7.86244981,13.4562378 C8.25104695,13.4562378 8.56599195,13.1414795 8.56599195,12.7531128 L8.56599195,8.98736573 C8.56599195,8.59918214 8.25104695,8.28424073 7.86244981,8.28424073 C3.52705463,8.28424073 0,11.8093872 0,16.1422119 C0,20.4750366 3.52705463,24 7.86244981,24 C12.197845,24 15.7250829,20.4750366 15.7250829,16.1422119 L15.7250829,9.30816652 C17.1253882,10.0543213 18.6834409,10.4437866 20.2964579,10.4437866 C20.685055,10.4437866 21,10.1290283 21,9.74066161 L21,5.97491456 C21,5.58673097 20.685055,5.27178956 20.2964579,5.27178956 Z M19.5929157,9.00842287 C18.0909266,8.88354492 16.6646048,8.35913086 15.4323068,7.47326662 C15.2181295,7.3190918 14.9356133,7.29785156 14.7005496,7.41833494 C14.4656692,7.53845212 14.3179986,7.78015134 14.3179986,8.04400636 L14.3179986,16.1422119 C14.3179986,19.6995849 11.4219334,22.59375 7.86244981,22.59375 C4.30296635,22.59375 1.40708428,19.6995849 1.40708428,16.1422119 C1.40708428,12.8223267 3.92920959,10.079956 7.15890767,9.72857667 L7.15890767,12.1104126 C5.23515968,12.4447632 3.76798118,14.1253052 3.76798118,16.1422119 C3.76798118,18.3986206 5.60470251,20.234436 7.86244981,20.234436 C10.1203804,20.234436 11.9571017,18.3986206 11.9571017,16.1422119 L11.9571017,1.40625 L14.3590386,1.40625 C14.6813122,4.14001462 16.8575292,6.31494141 19.5929157,6.63702394 L19.5929157,9.00842287 Z",
    id: "Shape"
  }))))));
};
Tiktok.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Tiktok.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Tiktok;